{
  "name": "agent-view",
  "version": "1.24.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "build:main": "ng build --aot --configuration production",
    "build:dev": "ng build --aot --configuration development"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.0.6",
    "@angular/cdk": "~21.0.5",
    "@angular/common": "^21.0.6",
    "@angular/compiler": "^21.0.6",
    "@angular/core": "^21.0.6",
    "@angular/forms": "^21.0.6",
    "@angular/platform-browser": "^21.0.6",
    "@angular/router": "^21.0.6",
    "@ngx-dropzone/cdk": "^21.0.0",
    "@primeuix/themes": "^1.2.3",
    "@tailwindcss/postcss": "^4.1.13",
    "@types/file-saver": "^2.0.7",
    "chart.js": "^4.5.1",
    "crypto": "^1.0.1",
    "dayjs": "^1.11.19",
    "file-saver": "^2.0.5",
    "html2canvas": "^1.4.1",
    "jspdf": "^3.0.4",
    "laravel-echo": "^2.2.6",
    "lottie-web": "^5.13.0",
    "ngx-lottie": "^20.0.0",
    "postcss": "^8.5.6",
    "primeng": "^21.0.2",
    "pusher-js": "^8.4.0",
    "quill": "^2.0.3",
    "rxjs": "~7.8.0",
    "tailwind-scrollbar-hide": "^4.0.0",
    "tailwindcss": "^4.1.13",
    "tailwindcss-primeui": "^0.6.1",
    "tslib": "^2.3.0",
    "uuid": "^13.0.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^21.0.3",
    "@angular/cli": "^21.0.3",
    "@angular/compiler-cli": "^21.0.6",
    "@types/chart.js": "^2.9.41",
    "@types/jasmine": "~5.1.0",
    "@types/jspdf": "^1.3.3",
    "@types/node": "^24.9.2",
    "@types/uuid": "^10.0.0",
    "baseline-browser-mapping": "^2.9.11",
    "jasmine-core": "~5.9.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "postcss": "^8.5.3",
    "typescript": "~5.9.2"
  }
}
